// @flow
import React, { Component, lazy, Suspense } from "react";

import CompanyTypeLabel from "../../components/companies/CompanyTypeLabel";
import LicenceCount from "../../components/companies/LicenceCount";
import { buildAdminCompanyHeading } from "../../../account/components/companies/CompileCompanytoJson";
import { LoadingProgress, NoItem } from "imagus-components";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Grid from "@material-ui/core/Grid";

const CompanyItem = lazy((): * => import("./CompanyAdminItem"));

type CompanyListStatesType = {
  expanded: null | boolean
};

type CompanyListPropsType = {
  companies: Array<*>,
  updateSearches: Function,
  openSnackbar: Function,
  companyFilter: Array<*>,
  typeFilter: string,
  tierFilter: string,
  priceFilter: string,
  billFilter: string
};

class CompanyList extends Component<
  CompanyListPropsType,
  CompanyListStatesType
> {
  constructor(props: CompanyListPropsType) {
    super(props);
    this.state = {
      expanded: null
    };
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false
    });
  };

  render(): * {
    const { expanded } = this.state;
    const companies = this.props.companies;
    const list =
      companies &&
      companies.map(
        (company: *, i: number): * => {
          let display = true;
          const companyHeader = buildAdminCompanyHeading(company, true);

          if (this.props.companyFilter && this.props.companyFilter.length > 0) {
            if (this.props.companyFilter.indexOf(companyHeader.id) < 0) {
              display = false;
            }
          }
          if (this.props.typeFilter && this.props.typeFilter !== "ALL") {
            if (
              this.props.typeFilter === "D" ||
              this.props.typeFilter === "E"
            ) {
              if (companyHeader.level !== this.props.typeFilter) {
                display = false;
              }
            } else {
              if (this.props.typeFilter === "A") {
                if (
                  companyHeader.authorisedReseller === -1 ||
                  companyHeader.level !== "R"
                ) {
                  display = false;
                }
              }
              if (this.props.typeFilter === "S") {
                if (
                  companyHeader.authorisedReseller !== -1 ||
                  companyHeader.level !== "R"
                ) {
                  display = false;
                }
              }
            }
          }
          if (this.props.tierFilter && this.props.tierFilter !== "ALL") {
            if (companyHeader.tierId !== this.props.tierFilter) {
              display = false;
            }
          }
          if (this.props.priceFilter && this.props.priceFilter !== "ALL") {
            if (companyHeader.productSheetId !== this.props.priceFilter) {
              display = false;
            }
          }
          if (this.props.billFilter && this.props.billFilter !== "ALL") {
            if (companyHeader.specialType !== this.props.billFilter) {
              display = false;
            }
          }

          if (display) {
            return (
              <ExpansionPanel
                expanded={expanded === company.id}
                onChange={this.handleChange(company.id)}
                key={i}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="subtitle1" className="heading">
                    {companyHeader.name}
                  </Typography>
                  <span className="subheading">
                    <LicenceCount count={companyHeader.licenceCount} />
                  </span>
                  <span className="subheading">
                    <CompanyTypeLabel
                      type={companyHeader.level}
                      authority={companyHeader.authorisedReseller}
                    />
                  </span>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Suspense fallback={<LoadingProgress />}>
                    {expanded === company.id && (
                      <CompanyItem
                        company={company}
                        updateSearches={this.props.updateSearches}
                        openSnackbar={this.props.openSnackbar}
                      />
                    )}
                  </Suspense>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            );
          } else {
            return null;
          }
        }
      );
    return (
      <div className="app-panel-content panel-top-margin">
        <Grid container spacing={24}>
          <Grid item xs={12}>
            {(list.filter(item => item !== null).length === 0 && (
              <NoItem content="No Company has found." />
            )) ||
              list}
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default CompanyList;
